import script from "./DivisionFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DivisionFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./DivisionFormModal.vue?vue&type=style&index=0&id=58eee3b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58eee3b4"]])

export default __exports__